import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { NavigationRule } from '../models/navigation-rule';
import { Page } from '../models/page';

@Injectable()
export class NavigationRuleService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  insertNavigationRule(
    page: Page,
    navigation_rule: NavigationRule,
    reference_navigation_rule: NavigationRule
  ): Observable<any> {
    let post_url = `${environment.surveyApiHost}/api/v1/surveys/${
      page.getSurvey().id
    }/pages/${page.id}/navigationrules/`;
    if (reference_navigation_rule != null) {
      post_url =
        post_url + `?ref_navigation_rule_id=${reference_navigation_rule.id}`;
    }
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, navigation_rule, { headers: headers })
      .map(this.processPostPutResponse)
      .catch(this.handleError);
  }

  updateNavigationRule(navigation_rule: NavigationRule): Observable<any> {
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${
      navigation_rule.getPage().getSurvey().id
    }/pages/${navigation_rule.getPage().id}/navigationsrules/${
      navigation_rule.id
    }/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    console.log('navigation_rule: ', navigation_rule.toJSON());
    return this.http
      .put(put_url, navigation_rule.toJSON(), { headers: headers })
      .catch(this.handleError);
  }

  deleteNavigationRule(navigation_rule: NavigationRule): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/surveys/${
      navigation_rule.getPage().getSurvey().id
    }/pages/${navigation_rule.getPage().id}/navigation_rules/${
      navigation_rule.id
    }/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  moveNavigationRule(
    navigation_rule: NavigationRule,
    new_order: number
  ): Observable<any> {
    let get_url = `${environment.surveyApiHost}/api/v1/surveys/${
      navigation_rule.getPage().getSurvey().id
    }/pages/${navigation_rule.getPage().id}/navigation_rules/${
      navigation_rule.id
    }/move`;
    if (new_order != null) {
      get_url = get_url + `?new_order=${new_order}`;
    }
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http.get(get_url, { headers: headers }).catch(this.handleError);
  }

  private processPostPutResponse(res: HttpResponse<any>): NavigationRule {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const navigation_rule: NavigationRule = Object.create(
      NavigationRule.prototype
    );
    const obj = Object.assign(navigation_rule, body, {});
    return obj || {};
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
